import {Component, Inject, Optional} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {S3UploaderRatioEnum, S3UploaderTypes, S3UploaderTypesEnum} from '../uploader/s3-uploader.types';

@Component({
  selector: 'app-s3-image-preview',
  templateUrl: './s3-image-preview.component.html',
  styleUrls: ['./s3-image-preview.component.scss']
})

export class S3ImagePreviewComponent {
  public title: string = 'general.api_image_preview_title';
  public model: string;
  public ratio: S3UploaderRatioEnum;
  public type: S3UploaderTypesEnum = S3UploaderTypes.Venue;
  public ownerCentreId: number;
  public ownerId: number;

  constructor(public dialogRef: MatDialogRef<S3ImagePreviewComponent>,
              @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
    this.dialogRef.addPanelClass('image-preview');
    if (data.title) this.title = data.title;
    if (data.model) this.model = data.model;
    if (data.ratio) this.ratio = data.ratio;
    if (data.type) this.type = data.type;
    if (data.ownerCentreId) this.ownerCentreId = data.ownerCentreId;
    if (data.ownerId) this.ownerId = data.ownerId;
  }
}
